import React, { useState } from "react";
import { motion } from "framer-motion";
import SEO from "../components/SEO";
import aboutData from "../data/about.json";

export default function About() {
  const [activeStep, setActiveStep] = useState(aboutData.workflow[0]);

  return (
    <div className="bg-slate-50">
      <SEO
        title={aboutData.seo?.title}
        description={aboutData.seo?.description}
        ogType="website"
        ogImage={aboutData.seo?.ogImage}
      />
      <section className="section-padding mx-auto w-full max-w-6xl">
        {/* <!-- Replace with dynamic content from JSON --> */}
        <p className="text-sm uppercase tracking-[0.2em] text-amber-600">
          {aboutData.seo?.title}
        </p>
        <h1 className="page-title mt-3">
          {aboutData.title}
        </h1>
        <p className="mt-4 text-lg text-slate-600">{aboutData.subtitle}</p>
      </section>

      <section className="section-padding bg-white">
        <div className="mx-auto grid w-full max-w-6xl gap-8 md:grid-cols-[1.1fr_0.9fr]">
          <div className="space-y-4">
            <h2 className="text-2xl font-semibold text-slate-900">
              {aboutData.subtitle}
            </h2>
            <p className="text-sm text-slate-600">{aboutData.mission}</p>
            <ul className="space-y-2 text-sm text-slate-600">
              {/* <!-- Replace with dynamic content from JSON --> */}
              {aboutData.values.map((value) => (
                <li key={value} className="flex items-center gap-2">
                  <span className="h-1.5 w-1.5 rounded-full bg-amber-500" />
                  {value}
                </li>
              ))}
            </ul>
          </div>
          <motion.div
            className="card relative flex h-64 items-center justify-center overflow-hidden border-dashed"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <div className="absolute inset-0 bg-gradient-to-br from-amber-100/40 via-white to-slate-100/40" />
            <div className="relative flex h-40 w-40 items-center justify-center">
              <div className="absolute h-40 w-40 rounded-full border-2 border-amber-200/70" />
              <div className="absolute h-28 w-28 animate-[spin_12s_linear_infinite] rounded-full border border-amber-300/70" />
              <div className="absolute h-10 w-10 animate-pulse rounded-full bg-amber-400/70" />
            </div>
            {/* Visual placeholder only. Replace with future animation asset. */}
          </motion.div>
        </div>
      </section>

      <section className="section-padding">
        <div className="mx-auto grid w-full max-w-6xl gap-6 md:grid-cols-[0.8fr_1.2fr]">
          <div className="space-y-3">
            {/* <!-- Replace with dynamic content from JSON --> */}
            {aboutData.workflow.map((step) => (
              <button
                key={step.title}
                type="button"
                onClick={() => setActiveStep(step)}
                className={`card flex w-full items-start gap-4 p-5 text-left transition ${
                  activeStep.title === step.title
                    ? "border-amber-500 text-slate-900 shadow-md"
                    : "text-slate-600 hover:border-amber-300"
                }`}
              >
                <div className="text-2xl">{step.icon}</div>
                <div>
                  <p className="text-base font-semibold text-slate-900">
                    {step.title}
                  </p>
                  <p className="mt-1 text-sm text-slate-600">
                    {step.description}
                  </p>
                </div>
              </button>
            ))}
          </div>

          <div className="card p-6">
            <p className="text-sm text-slate-600">{activeStep.description}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
